<template>
	<div class="card-head">
		<div>
			<img src="../../../../assets/yq/icon_index.png" alt="" srcset="">
			<span class="head-title">{{ title }}</span>
		</div>
		<div class="head-select" v-if="options.length > 0">
			<el-select v-model="currentValue" :popper-append-to-body='false' size='mini' style="text-alight: right"
				placeholder="请选择">
				<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
				</el-option>
			</el-select>
		</div>
		<div class="head-right" v-if='dropdownList.length > 0'>
			<el-dropdown trigger="click" @command="handleCommand">
				<span class="el-dropdown-link">
					{{ currentName }}<i class="el-icon-caret-bottom el-icon--right"></i>
				</span>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item v-for='(item, index) in dropdownList' :command='item'
						:key='index'>{{ item.name }}</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		title: {
			type: String,
			default: '',
		},
		optionsList: Array,
		dropdownList: {
			tyep: Array,
			default: () => {
				return [
					// {name:'选项1',id:1},
					// {name:'选项2',id:2},
					// {name:'选项3',id:3}
				]
			}
		}
	},
	data() {
		return {
			currentValue: 1,
			options: [],
			currentValue: '',
			currentName: '',
		}
	},
	watch: {
		optionsList() {
			if (this.optionsList && this.optionsList.length > 0) {
				this.options = this.optionsList
				this.currentValue = this.optionsList[0].value
			}
		}
	},
	async created() {
		if (this.optionsList && this.optionsList.length > 0) {
			this.options = this.optionsList
			this.currentValue = this.optionsList[0].value
		}
		this.currentName = this.dropdownList[0]?.name
	},

	methods: {
		handleCommand(command) {
			this.currentName = command.name
			console.log(this.currentName)
			this.$emit('changeTab', command)
		},
		changeSelect(value) {
			this.currentValue = value
			this.$emit('changeTab', value)
		},
	},
};
</script>
<style lang="scss" scoped>
.card-head {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding-left: 0.11rem;
	height: 0.5rem;
	background: linear-gradient(90deg, rgba(17, 147, 255, 0.52) 0%, rgba(17, 147, 255, 0) 100%);
	justify-content: space-between;

	img {
		width: 0.25rem;
		height: 0.25rem;
		margin-right: 0.25rem;
		animation-name: identifier;
		animation-duration: 2s;
		animation-direction: normal;
		animation-iteration-count: infinite;
		animation-timing-function:linear;
	}

	.head-title {
		font-size: 0.28rem;
		font-family: Source Han Sans CN-Medium, Source Han Sans CN;
		font-weight: 500;
		color: #FFFFFF;
		line-height: 0.28rem;
	}

	.head-right {
		margin-right: 0.26rem;

		.el-dropdown-link {
			font-size: 0.23rem;
			font-family: Source Han Sans CN-Medium, Source Han Sans CN;
			font-weight: 500;
			color: #FFFFFF;
		}
	}

}

@keyframes identifier {
	0% {transform: rotateZ(0deg);}
    100% {transform: rotateZ(360deg);}
}

:deep(.el-input--mini .el-input__inner) {
	width: 1rem;
	text-align: right;
	background: transparent;
	border: none;
	color: #fff;
}

:deep(.el-popper[x-placement^=bottom] .popper__arrow::after) {
	border-bottom-color: #0B286A
}

:deep(.el-select-dropdown) {
	background-color: rgba(196, 196, 196, 0.01);
	border-color: rgba(0, 246, 236, 0.2);
	color: #fff;
}

:deep(.el-select-dropdown__item) {
	color: #fff;
}

:deep(.el-select-dropdown__item.hover) {
	background: transparent;
}

:deep(.el-icon-arrow-up:before) {
	content: "\e78f";
}</style>